import React from "react";
import { Handle, Position } from "reactflow";
import { ProfileOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../../ButtonDelete";
import { useFlowNodes } from "../../../context";
import Contexts from "components/Accordion/AccordionIntents/contexts";
import { handleDeleteConstexResponses } from "../../utils/removeDataNode";

import "./ContextOutputIntentNode.scss";

export const ContextOutputIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, contexts, ...res } = useFlowNodes();
  return (
    <div className="context-node">
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />

      <div className="context-header">
        <div className="context-title">
          <div className="context-icon">
            <ProfileOutlined />
          </div>
          <span className="context-name">
            {t("common:intents.flow_chat.context.title")}
          </span>
        </div>
        <span className="context-add-button">
          <ButtonDelete
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
            handleDelete={() => handleDeleteConstexResponses(res.updateIntent)}
          />
        </span>
      </div>

      <div className={"accordion__content"}>
        <Contexts
          key="phrases"
          context_type="output"
          contexts={contexts || []}
          {...{
            id,
            setNodes,
            setEdges,
            contexts,
            ...res,
            t,
            type: "responses",
            isFlow: true,
          }}
        />
      </div>
    </div>
  );
};
